import Dashboard from "views/Dashboard/Dashboard.jsx";
import Consulta from "views/TableList/ConsultaCorte.jsx";

var dashRoutes = [
  {
    path: "/admin/menu",
    name: "Menu",
    icon: "nc-icon nc-book-bookmark",
    component: Dashboard,
  },
  {
    path: "/Corte/Procesos",
    name: "Procesos",
    icon: "nc-icon nc-briefcase-24",
    component: Consulta,
  },
  {
    redirect: true,
    path: "/",
    pathTo: "/Corte/Procesos",
    name: "Registro",
  },
];

export default dashRoutes;
